/*通用全局变量存储库*/

/*获取vue实例*/
import customer_draw from "../../../../components/2DMap/draw_tool/customerDraw";
import roller_provider from './roller_tool'
import Vue from "vue";
let get_main_vue = () => {
  return window.vue
}
let eventBus = new Vue();
export default {
  eventBus,
  cur_qhdm:'43',/*当前区划代码*/
  cur_year:'',/*当前年份*/

  compare_map:'',/*对比地图实例*/
  sys_map:"",/*系统地图实例，即系统主map实例*/
  djdb_map:"",/*专题图耕地与确权叠加用map实例*/
  sys_map_rightL:'',/*主地图的对比地图*/
  sys_ztt_map:"",/*系统专题图map实例*/
  sys_ztt_map2:"",/*系统专题图卷帘实例*/

  _l3_qhdat:[],/*省市县三级行政区划数据*/

  roller_provider:roller_provider,


  ori_layerids:[],/*原始地图id*/

  layer_ids_i_search:['县级行政区2022年'],/*支持i查询的图层id*/

  init_bbox:[135.05,53.34,73.33,3.51],/*初始定位信息，[lng,lat,lnt,lat]*/

  cur_dynamic_image_service_publish_item:"",/*动态栅格服务发布，当前的影像数据对象*/
  is_dynamic_image_service_dialog_random:"",/*每次打开弹窗，生成一个新的随机码，渲染方案里面用*/

  compare_map_l:"",/*卷帘地图左*/
  compare_map_r:'',/*卷帘地图右*/
  custom_draw_compare_map_l:'',/*对比卷帘绘制*/
  warehouseID:'',
}



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/sys_tool/common_store.js